import React from 'react';
import autoBind from 'react-autobind';
import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';
import Field from '@common/components/validation/field.validation';
import { OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';
import { Select, Tag } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

import _ from 'lodash';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  tagRender(props) {
    const { isView } = this.props;

    const label = typeof props === 'string' ? props : props && (props.label || props.Texto);

    return (
      label && (
        <Tag
          style={{
            textAlign: 'center',
          }}
          icon={
            !isView && (
              <CloseOutlined
                className="float-right"
                style={{
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  lineHeight: 'normal',
                  marginLeft: '5px',
                }}
                onClick={props.onClose}
              />
            )
          }
        >
          {label}
        </Tag>
      )
    );
  }

  mapComboBoxToComponentItens(combobox) {
    return (
      combobox &&
      combobox.map((item) => (this.isObject(item) ? { ...item, value: this.getItemValue(item) } : { value: item }))
    );
  }

  mapComboBoxToComponentValues(combobox) {
    return combobox && combobox.map((item) => (this.isObject(item) ? this.getItemValue(item) : item));
  }

  getItemValue(item) {
    return item[this.props.mapItemProp || 'Texto'];
  }

  isObject(item) {
    return typeof item === 'object';
  }

  renderComponent() {
    const { props } = this;
    const { Label, Tooltip, Desabilitado, Placeholder, name, state, itens, PlacementTooltip, maxTagCount } = props;

    return (
      <Field {...props} state={state}>
        {({ value, hasError, onChange }) => {
          return (
            <LabeledInput {...props}>
              <OverlayTrigger
                key={`top-${name}`}
                placement={PlacementTooltip || 'top'}
                overlay={
                  <TooltipBootstrap id={`tooltip-${name}`}>
                    <div className={'fontTooltip'}>{Tooltip || Label}</div>
                  </TooltipBootstrap>
                }
              >
                <Select
                  name={name}
                  value={this.mapComboBoxToComponentValues(state)}
                  mode="multiple"
                  disabled={Desabilitado}
                  style={{ width: '100%', borderRadius: '4px' }}
                  placeholder={Placeholder || Label}
                  options={this.mapComboBoxToComponentItens(itens)}
                  notFoundContent={
                    <div style={{ textAlign: 'center' }}>
                      <p style={{ color: 'black' }}>Nenhum registro encontrado...</p>
                    </div>
                  }
                  tagRender={(props) => this.tagRender(props)}
                  className={`${hasError ? 'form-invalid' : ''}`}
                  maxTagCount={maxTagCount}
                  showArrow={true}
                  onChange={(value) => onChange(value)}
                  getPopupContainer={(trigger) => trigger.parentNode}
                />
              </OverlayTrigger>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <span>
                <label className="form-control" style={this.props.viewStyle} readOnly>
                  {(field.state && field.state.map((item) => this.tagRender(item))) || ''}
                </label>
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }
}

export default DDadosComponent;
